/**
 * @format
 */

import React from 'react';
import { StyleSheet, View } from 'react-native';

import {
  Advertisement,
  FullCategory,
  FullThumbtackCategory,
  ThumbtackPro,
} from '../../../api/adserver';
import Divider from '../divider';

import CategoryListItem from './CategoryListItem';

export interface Props {
  advertCategoryForIndex: (index: number) => any; //change from any
  categoryCount: number;
  renderItemForIndex: (
    index: number,
  ) => ((item: any) => JSX.Element | null) | null;
  onPress?: (
    item: Advertisement | ThumbtackPro,
    category: FullCategory,
  ) => void;
  onPressCategory?: (item: FullCategory | FullThumbtackCategory) => void;
}

const CategoryListRender: React.FC<Props> = (props) => {
  const { advertCategoryForIndex, categoryCount, renderItemForIndex } = props;
  if (!categoryCount) {
    return null;
  }
  return (
    <>
      {Array(categoryCount)
        .fill(0)
        .map((_item, index) => {
          const category = advertCategoryForIndex(index);
          if (!category) {
            return null;
          }
          return (
            <View key={category.id}>
              <CategoryListItem
                item={category}
                renderItem={renderItemForIndex(index)}
                onPress={(item: Advertisement | ThumbtackPro) =>
                  props.onPress && props.onPress(item, category)
                }
                onPressCategory={props.onPressCategory}
              />
              <Divider containerStyle={styles.divider} large />
            </View>
          );
        })}
    </>
  );
};

const styles = StyleSheet.create({
  divider: {
    marginLeft: -15,
    width: 2000,
    marginTop: 10,
  },
});

export default CategoryListRender;
